import React from 'react';
import { Link } from 'react-router-dom';
import './PageHero.css';

/**
 * Unified page header band for inner routes (matches home brand styling).
 */
const PageHero = ({ title, subtitle, breadcrumb }) => (
  <header className="page-hero">
    <div className="page-hero-inner">
      {breadcrumb && breadcrumb.length > 0 && (
        <nav className="page-hero-breadcrumb" aria-label="Breadcrumb">
          {breadcrumb.map((item, index) => (
            <span key={item.label}>
              {item.href ? (
                <Link to={item.href}>{item.label}</Link>
              ) : (
                <span aria-current="page">{item.label}</span>
              )}
              {index < breadcrumb.length - 1 && <span className="sep">/</span>}
            </span>
          ))}
        </nav>
      )}
      <h1 className="page-hero-title">{title}</h1>
      {subtitle && <p className="page-hero-subtitle">{subtitle}</p>}
    </div>
  </header>
);

export default PageHero;
